import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './modules/login/login.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { ApplicantDetailComponent } from './modules/applicant-detail/applicant.detail.component';
import { ApplicantListComponent } from './modules/applicant-list/applicant-list.component';
import { NgModule } from '@angular/core';
import { ApplicationFormComponent } from './modules/application-form/application-form.component';
import { AuthGuardService } from './service/auth-guard.service';
import { UserManagementComponent } from './modules/user-management/user-management.component';
import { CaseDetailComponent } from './modules/case-detail/case-detail.component';
import { CaseListComponent } from './modules/case-list/case-list.component';
import { PreviewApplicationFormComponent } from './modules/preview-application-form/preview-application-form.component';
import { AccountSetupSuccessComponent } from './modules/account-setup-success/account-setup-success.component';
import { AccountSetupComponent } from './modules/account-setup/account-setup.component';

export const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'rider', loadChildren: () => import('./features/rider/rider.routes').then(m => m.riderRoutes) },
  { path: ':agencySlug/rider', loadChildren: () => import('./features/rider/rider.routes').then(m => m.riderRoutes) },
  { path: 'dashboard', component: DashboardComponent,canActivate : [AuthGuardService]},
  { path: 'application-form', component: ApplicationFormComponent, pathMatch:'full', canActivate : [AuthGuardService] },
  { path: 'applicant-list', component: ApplicantListComponent, canActivate : [AuthGuardService] },
  { path:'applicant-detail', component: ApplicantDetailComponent, canActivate : [AuthGuardService] },
  { path:'user-management', component: UserManagementComponent,canActivate : [AuthGuardService] },
  { path:'case-list', component: CaseListComponent, canActivate : [AuthGuardService] },
  { path:'case-detail', component: CaseDetailComponent, canActivate : [AuthGuardService] },
  { path:'preview-application-form', component: PreviewApplicationFormComponent },
  { path:'account-setup', component: AccountSetupComponent },
  { path:'account-setup-success', component: AccountSetupSuccessComponent },
  { path: '**', redirectTo: '' } // Redirect unknown routes to login
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
